jQuery(document).ready(function() {
  //HOME BANNER SLIDER
    jQuery(".hero_slider_content").slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
    }); 
    $(".review_slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 300,
      prevArrow: $(".slider_controls .slide-prev"),
      nextArrow: $(".slider_controls .slide-next"),
      responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    }); 
  });
  